{
  "about.blocks": "خوادم تحت الإشراف",
  "about.contact": "للاتصال:",
  "about.default_locale": "افتراضي",
  "about.disclaimer": "ماستدون برنامج حر ومفتوح المصدر وعلامة تجارية لـ Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "السبب غير متوفر",
  "about.domain_blocks.preamble": "يتيح مَستُدون عمومًا لمستخدميه مطالعة المحتوى من المستخدمين من الخواديم الأخرى في الفدرالية والتفاعل معهم. وهذه هي الاستثناءات التي وضعت على هذا الخادوم.",
  "about.domain_blocks.silenced.explanation": "لن تظهر لك ملفات التعريف الشخصية والمحتوى من هذا الخادوم، إلا إن بحثت عنه عمدًا أو تابعته.",
  "about.domain_blocks.silenced.title": "محدود",
  "about.domain_blocks.suspended.explanation": "لن يتم معالجة أي بيانات من هذا الخادم أو تخزينها أو تبادلها، مما يجعل أي تفاعل أو اتصال مع المستخدمين من هذا الخادم مستحيلا.",
  "about.domain_blocks.suspended.title": "مُعلّق",
  "about.language_label": "اللغة",
  "about.not_available": "لم يتم توفير هذه المعلومات على هذا الخادم.",
  "about.powered_by": "شبكة اجتماعية لامركزية مدعومة من {mastodon}",
  "about.rules": "قواعد الخادم",
  "account.account_note_header": "ملاحظة شخصية",
  "account.activity": "النشاط",
  "account.add_note": "إضافة ملاحظة شخصية",
  "account.add_or_remove_from_list": "الإضافة أو الإزالة من القائمة",
  "account.badges.admin": "مدير",
  "account.badges.blocked": "محظور",
  "account.badges.bot": "آلي",
  "account.badges.domain_blocked": "النطاق محظور",
  "account.badges.group": "فريق",
  "account.badges.muted": "مكتوم",
  "account.badges.muted_until": "مكتوم إلى غاية {until}",
  "account.block": "احجب @{name}",
  "account.block_domain": "حظر اسم النِّطاق {domain}",
  "account.block_short": "حظر",
  "account.blocked": "محظور",
  "account.cancel_follow_request": "إلغاء طلب المتابعة",
  "account.copy": "نسخ الرابط إلى الملف الشخصي",
  "account.direct": "إشارة خاصة لـ @{name}",
  "account.disable_notifications": "توقف عن إشعاري عندما ينشر @{name}",
  "account.edit_note": "تعديل الملاحظة الشخصية",
  "account.edit_profile": "تعديل الملف الشخصي",
  "account.edit_profile_short": "تعديل",
  "account.enable_notifications": "أشعرني عندما ينشر @{name}",
  "account.endorse": "أوصِ به على صفحتك الشخصية",
  "account.familiar_followers_many": "يتبعه {name1}، {name2} و{othersCount, plural, one {شخص آخر تعرفه} other {# أشخاص آخرون تعرفهم}}",
  "account.familiar_followers_one": "يتبعه {name1}",
  "account.familiar_followers_two": "يتبعه {name1} و {name2}",
  "account.featured": "معروض",
  "account.featured.accounts": "ملفات شخصية",
  "account.filters.all": "جميع الأنشطة",
  "account.filters.boosts_toggle": "اعرض المعاد نشرها",
  "account.filters.posts_boosts": "المنشورات والمعاد نشرها",
  "account.filters.posts_only": "منشورات",
  "account.filters.posts_replies": "المنشورات والردود",
  "account.filters.replies_toggle": "اعرض الردود",
  "account.follow": "متابعة",
  "account.follow_back": "تابعه بالمثل",
  "account.follow_back_short": "تابعه بالمثل",
  "account.follow_request": "طلب المتابعة",
  "account.follow_request_cancel": "إلغاء الطلب",
  "account.follow_request_cancel_short": "إلغاء",
  "account.follow_request_short": "طلب المتابعة",
  "account.followers": "مُتابِعون",
  "account.followers.empty": "لا أحدَ يُتابع هذا المُستخدم إلى حد الآن.",
  "account.followers_counter": "{count, plural, zero{لا مُتابع} one {مُتابعٌ واحِد} two {مُتابعانِ اِثنان} few {{counter} مُتابِعين} many {{counter} مُتابِعًا} other {{counter} مُتابع}}",
  "account.followers_you_know_counter": "{counter} شخص تعرفه",
  "account.following": "الاشتراكات",
  "account.following_counter": "{count, plural, zero{لا يُتابِع أحدًا} one {يُتابِعُ واحد} two{يُتابِعُ اِثنان} few{يُتابِعُ {counter}} many{يُتابِعُ {counter}} other {يُتابِعُ {counter}}}",
  "account.follows.empty": "لا يُتابع هذا المُستخدمُ أيَّ أحدٍ حتى الآن.",
  "account.follows_you": "يتابعك",
  "account.go_to_profile": "اذهب إلى الملف الشخصي",
  "account.hide_reblogs": "إخفاء المعاد نشرها مِن @{name}",
  "account.in_memoriam": "في الذكرى.",
  "account.joined_short": "انضم في",
  "account.languages": "تغيير اللغات المشترَك فيها",
  "account.last_active": "آخر نشاط",
  "account.link_verified_on": "تمَّ التَّحقق مِن مِلْكيّة هذا الرابط بتاريخ {date}",
  "account.locked_info": "تم ضبط حالة خصوصية هذا الحساب على أنه مؤمّن. إذ يراجع صاحبه يدويًا من يُسمح له بالمتابعة.",
  "account.media": "وسائط",
  "account.mention": "أذكُر @{name}",
  "account.menu.add_to_list": "إضافة إلى القائمة…",
  "account.menu.block": "حظر الحساب",
  "account.menu.block_domain": "حظر {domain}",
  "account.menu.copied": "تم نسخ رابط الحساب إلى الحافظة",
  "account.menu.copy": "نسخ الرابط",
  "account.menu.direct": "إشارة خاصة لـ",
  "account.menu.mention": "إشارة",
  "account.menu.mute": "كتم الحساب",
  "account.menu.note.description": "مرئي لك فقط",
  "account.menu.remove_follower": "إزالة المتابِع",
  "account.menu.report": "الإبلاغ عن الحساب",
  "account.menu.share": "مشاركة…",
  "account.menu.unblock": "رفع الحظر عن الحساب",
  "account.menu.unblock_domain": "رفع الحظر عن {domain}",
  "account.menu.unmute": "إلغاء كتم الحساب",
  "account.moved_to": "أشار {name} إلى أن حسابه الجديد الآن:",
  "account.mute": "أكتم @{name}",
  "account.mute_notifications_short": "كتم الإشعارات",
  "account.mute_short": "اكتم",
  "account.muted": "مَكتوم",
  "account.mutual": "أنتم تتابعون بعضكم البعض",
  "account.name.copy": "نسخ المعرف",
  "account.name_info": "ما معنى ذلك؟",
  "account.no_bio": "لم يتم تقديم وصف.",
  "account.node_modal.edit_title": "تعديل الملاحظة الشخصية",
  "account.node_modal.error_unknown": "تعذر حفظ الملاحظة",
  "account.node_modal.field_label": "ملاحظة شخصية",
  "account.node_modal.save": "حفظ",
  "account.node_modal.title": "إضافة ملاحظة شخصية",
  "account.note.edit_button": "تعديل",
  "account.note.title": "ملاحظة شخصية (مرئية لك فقط)",
  "account.open_original_page": "افتح الصفحة الأصلية",
  "account.posts": "منشورات",
  "account.remove_from_followers": "إزالة {name} من المتابعين",
  "account.report": "الإبلاغ عن @{name}",
  "account.requested_follow": "لقد طلب {name} متابعتك",
  "account.share": "شارِك الملف التعريفي لـ @{name}",
  "account.show_reblogs": "اعرض إعادات نشر @{name}",
  "account.statuses_counter": "{count, plural, zero {}one {{counter} مشور} two {{counter} منشور} few {{counter} منشور} many {{counter} منشور} other {{counter} منشور}}",
  "account.timeline.pinned": "مثبّت",
  "account.timeline.pinned.view_all": "عرض جميع المنشورات المثبتة",
  "account.unblock": "إلغاء الحَظر عن @{name}",
  "account.unblock_domain": "إلغاء الحَظر عن النِّطاق {domain}",
  "account.unblock_domain_short": "رفع الحظر",
  "account.unblock_short": "ألغ الحجب",
  "account.unendorse": "لا تُرَوِّج لهُ في الملف الشخصي",
  "account.unfollow": "إلغاء المُتابعة",
  "account.unmute": "إلغاء الكَتم عن @{name}",
  "account.unmute_notifications_short": "إلغاء كَتم الإشعارات",
  "account.unmute_short": "إلغاء الكتم",
  "account_edit.advanced_settings.bot_label": "حساب آلي",
  "account_edit.advanced_settings.title": "الإعدادات المتقدمة",
  "account_edit.bio.add_label": "إضافة سيرة ذاتية",
  "account_edit.bio.edit_label": "تعديل السيرة الذاتية",
  "account_edit.bio.title": "نبذة عنك",
  "account_edit.bio_modal.add_title": "إضافة سيرة ذاتية",
  "account_edit.bio_modal.edit_title": "تعديل السيرة الذاتية",
  "account_edit.column_button": "تمّ",
  "account_edit.column_title": "تعديل الملف الشخصي",
  "account_edit.custom_fields.add_label": "إضافة حقل",
  "account_edit.custom_fields.edit_label": "تعديل الحقل",
  "account_edit.custom_fields.placeholder": "أضف ضمائر أو روابط خارجية أو أي شيء آخر ترغب في مشاركته.",
  "account_edit.custom_fields.reorder_button": "إعادة ترتيب الحقول",
  "account_edit.custom_fields.tip_title": "نصيحة: إضافة روابط متحقق منها",
  "account_edit.custom_fields.title": "الحقول المخصصة",
  "account_edit.custom_fields.verified_hint": "كيف يمكنني إضافة رابط متحقق منه؟",
  "account_edit.display_name.add_label": "إضافة اسم علني",
  "account_edit.display_name.edit_label": "تعديل الاسم العلني",
  "account_edit.display_name.title": "الاسم العلني",
  "account_edit.featured_hashtags.edit_label": "إضافة وسوم",
  "account_edit.featured_hashtags.title": "الوسوم المروّجة",
  "account_edit.field_actions.delete": "حذف الحقل",
  "account_edit.field_actions.edit": "تعديل الحقل",
  "account_edit.field_delete_modal.delete_button": "حذف",
  "account_edit.field_delete_modal.title": "أتريد حذف الحقل المخصص؟",
  "account_edit.field_edit_modal.add_title": "إضافة حقل مخصص",
  "account_edit.field_edit_modal.discard_confirm": "تجاهل",
  "account_edit.field_edit_modal.edit_title": "تعديل الحقل المخصص",
  "account_edit.field_edit_modal.name_hint": "على سبيل المثال \"الموقع الشخصي\"",
  "account_edit.field_edit_modal.name_label": "التسمية",
  "account_edit.field_edit_modal.url_warning": "لإضافة رابط ، يرجى تضمين {protocol} في البداية.",
  "account_edit.field_edit_modal.value_hint": "على سبيل المثال \"https://example.me\"",
  "account_edit.field_edit_modal.value_label": "قيمة",
  "account_edit.image_alt_modal.add_title": "إضافة نص بديل",
  "account_edit.image_alt_modal.edit_title": "تعديل نص بديل",
  "account_edit.image_alt_modal.text_label": "نص بديل",
  "account_edit.image_delete_modal.delete_button": "حذف",
  "account_edit.image_edit.add_button": "إضافة صورة",
  "account_edit.image_edit.alt_add_button": "إضافة نص بديل",
  "account_edit.image_edit.alt_edit_button": "تعديل نص بديل",
  "account_edit.image_edit.remove_button": "إزالة الصورة",
  "account_edit.image_edit.replace_button": "استبدال الصورة",
  "account_edit.item_list.delete": "حذف {name}",
  "account_edit.item_list.edit": "تعديل {name}",
  "account_edit.profile_tab.button_label": "تخصيص",
  "account_edit.save": "حفظ",
  "account_edit.upload_modal.back": "العودة",
  "account_edit.upload_modal.done": "تمّ",
  "account_edit.upload_modal.next": "التالي",
  "account_edit.upload_modal.step_crop.zoom": "تكبير",
  "account_edit.upload_modal.step_upload.button": "تصفح الملفات",
  "account_edit.upload_modal.step_upload.dragging": "إسقاط للتحميل",
  "account_edit.upload_modal.step_upload.header": "اختيار صورة",
  "account_edit.upload_modal.title_add.avatar": "إضافة صورة الملف الشخصي",
  "account_edit.upload_modal.title_add.header": "إضافة صورة الغلاف",
  "account_edit.upload_modal.title_replace.avatar": "استبدال صورة الملف الشخصي",
  "account_edit.upload_modal.title_replace.header": "استبدال صورة الغلاف",
  "account_edit_tags.add_tag": "إضافة #{tagName}",
  "account_edit_tags.suggestions": "الاقتراحات:",
  "account_note.placeholder": "اضغط لإضافة مُلاحظة",
  "admin.dashboard.daily_retention": "معدّل بقاء المستخدمين بعد إنشاء الحسابات، بالأيام",
  "admin.dashboard.monthly_retention": "معدّل بقاء المستخدمين بعد إنشاء الحسابات، بالشهور",
  "admin.dashboard.retention.average": "المعدل",
  "admin.dashboard.retention.cohort": "شهر التسجيل",
  "admin.dashboard.retention.cohort_size": "المستخدمون الجدد",
  "admin.impact_report.instance_accounts": "ملفات حسابات سوف يتم حذفها",
  "admin.impact_report.instance_followers": "المتابِعون الذين سوف يخسرهم مستخدمونا",
  "admin.impact_report.instance_follows": "المتابِعون الذين سوف يخسرهم مستخدموهم",
  "admin.impact_report.title": "موجز التأثير",
  "alert.rate_limited.message": "يُرجى إعادة المحاولة بعد {retry_time, time, medium}.",
  "alert.rate_limited.title": "معدل الطلبات محدود",
  "alert.unexpected.message": "لقد طرأ خطأ غير متوقّع.",
  "alert.unexpected.title": "المعذرة!",
  "alt_text_badge.title": "نص بديل",
  "alt_text_modal.add_alt_text": "أضف نصًا بديلًا",
  "alt_text_modal.add_text_from_image": "أضف النص من الصورة",
  "alt_text_modal.cancel": "إلغاء",
  "alt_text_modal.change_thumbnail": "غيّر الصورة المصغرة",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "قم بوصفها للأشخاص ذوي الإعاقة السمعية…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "قم بوصفها للأشخاص ذوي الإعاقة البصرية…",
  "alt_text_modal.done": "تمّ",
  "announcement.announcement": "إعلان",
  "annual_report.announcement.action_dismiss": "لا شكراً",
  "annual_report.nav_item.badge": "جديد",
  "annual_report.shared_page.donate": "تبرع",
  "annual_report.summary.archetype.oracle.name": "الحكيم",
  "annual_report.summary.archetype.replier.name": "الفراشة",
  "annual_report.summary.close": "اغلق",
  "annual_report.summary.copy_link": "نسخ الرابط",
  "annual_report.summary.most_used_app.most_used_app": "التطبيق الأكثر استخداماً",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "الهاشتاق الأكثر استخداماً",
  "annual_report.summary.new_posts.new_posts": "المنشورات الجديدة",
  "annual_report.summary.percentile.text": "<topLabel>هذا يجعلك من بين أكثر </topLabel><percentage></percentage><bottomLabel>مستخدمي {domain} نشاطاً </bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "سيبقى هذا الأمر بيننا.",
  "annual_report.summary.share_elsewhere": "شاركها في مكان آخر",
  "annual_report.summary.share_on_mastodon": "شاركها على ماستدون",
  "attachments_list.unprocessed": "(غير معالَج)",
  "audio.hide": "إخفاء المقطع الصوتي",
  "block_modal.remote_users_caveat": "سوف نطلب من الخادم {domain} أن يحترم قرارك، لكن الالتزام غير مضمون لأن بعض الخواديم قد تتعامل مع نصوص الكتل بشكل مختلف. قد تظل المنشورات العامة مرئية للمستخدمين غير المسجلين الدخول.",
  "block_modal.show_less": "تفاصيل أقلّ",
  "block_modal.show_more": "تفاصيل أكثر",
  "block_modal.they_will_know": "سيعلم أنه قد حُظِر.",
  "block_modal.title": "أتريد حظر هذا المستخدم؟",
  "boost_modal.combo": "يُمكنك الضّغط على {combo} لتخطي هذا في المرة المُقبلة",
  "boost_modal.reblog": "أتريد إعادة نشر المنشور؟",
  "boost_modal.undo_reblog": "أتريد إلغاء إعادة نشر المنشور؟",
  "bundle_column_error.copy_stacktrace": "انسخ تقرير الخطأ",
  "bundle_column_error.error.body": "لا يمكن تقديم الصفحة المطلوبة. قد يكون بسبب خطأ في التعليمات البرمجية، أو مشكلة توافق المتصفح.",
  "bundle_column_error.error.title": "أوه لا!",
  "bundle_column_error.network.body": "حدث خطأ أثناء محاولة تحميل هذه الصفحة. قد يكون هذا بسبب مشكلة مؤقتة في اتصالك بالإنترنت أو هذا الخادم.",
  "bundle_column_error.network.title": "خطأ في الشبكة",
  "bundle_column_error.retry": "إعادة المُحاولة",
  "bundle_column_error.return": "العودة إلى الرئيسية",
  "bundle_column_error.routing.body": "تعذر العثور على الصفحة المطلوبة. هل أنت متأكد من أنّ الرابط التشعبي URL في شريط العناوين صحيح؟",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "إغلاق",
  "bundle_modal_error.message": "حدث خطأ أثناء تحميل هذه الشاشة.",
  "bundle_modal_error.retry": "إعادة المُحاولة",
  "callout.dismiss": "تجاهل",
  "closed_registrations.other_server_instructions": "بما أن ماستدون لامركزي، يمكنك إنشاء حساب على خادم آخر للاستمرار في التفاعل مع هذا الخادم.",
  "closed_registrations_modal.description": "لا يمكن إنشاء حساب على {domain} حاليا، ولكن على فكرة لست بحاجة إلى حساب على {domain} بذاته لاستخدام ماستدون.",
  "closed_registrations_modal.find_another_server": "ابحث على خادم آخر",
  "closed_registrations_modal.preamble": "ماستدون لامركزي، لذلك بغض النظر عن مكان إنشاء حسابك، سيكون بإمكانك المتابعة والتفاعل مع أي شخص على هذا الخادم. يمكنك حتى أن تستضيفه ذاتياً!",
  "closed_registrations_modal.title": "إنشاء حساب على ماستدون",
  "collection.share_modal.share_link_label": "مشاركة الرابط",
  "collection.share_modal.share_via_post": "نشر على ماستدون",
  "collections.block_collection_owner": "حظر الحساب",
  "collections.by_account": "مِن {account_handle}",
  "collections.collection_description": "الوصف",
  "collections.collection_language": "اللغة",
  "collections.collection_language_none": "لا شيء",
  "collections.collection_name": "الاسم",
  "collections.collection_topic": "الموضوع",
  "collections.content_warning": "تحذير عن المحتوى",
  "collections.continue": "مواصلة",
  "collections.copy_link": "نسخ الرابط",
  "collections.copy_link_confirmation": "نسخ الرابط إلى الحافظة",
  "collections.create.basic_details_title": "المعلومات الأساسية",
  "collections.create.steps": "الخطوة {step}/{total}",
  "collections.detail.revoke_inclusion": "أزلني",
  "collections.detail.sensitive_content": "محتوى حساس",
  "collections.edit_details": "تعديل التفاصيل",
  "collections.hints.accounts_counter": "{count}/{max} حسابات",
  "collections.manage_accounts": "إدارة الحسابات",
  "collections.remove_account": "إزالة",
  "collections.sensitive": "حساس",
  "collections.share_short": "مشاركة",
  "collections.visibility_public": "للعامة",
  "collections.visibility_title": "مدى الظهور",
  "collections.visibility_unlisted": "غير مُدرَج",
  "column.about": "عن",
  "column.blocks": "المُستَخدِمون المَحظورون",
  "column.bookmarks": "الفواصل المرجعية",
  "column.community": "الخيط الزمني المحلي",
  "column.create_list": "إنشاء القائمة",
  "column.direct": "الإشارات الخاصة",
  "column.directory": "تَصَفُّحُ المَلفات الشخصية",
  "column.domain_blocks": "النطاقات المحظورة",
  "column.edit_list": "تعديل القائمة",
  "column.favourites": "المفضلة",
  "column.firehose": "الموجزات الحية",
  "column.follow_requests": "طلبات المتابعة",
  "column.home": "الرئيسية",
  "column.list_members": "إدارة أعضاء القائمة",
  "column.lists": "القوائم",
  "column.mutes": "المُستَخدِمون المَكتومون",
  "column.notifications": "الإشعارات",
  "column.pins": "المنشورات المُثَبَّتَة",
  "column.public": "الخيط الفيدرالي",
  "column_back_button.label": "العودة",
  "column_header.hide_settings": "إخفاء الإعدادات",
  "column_header.moveLeft_settings": "نقل العامود إلى اليسار",
  "column_header.moveRight_settings": "نقل العامود إلى اليمين",
  "column_header.pin": "تثبيت",
  "column_header.show_settings": "إظهار الإعدادات",
  "column_header.unpin": "إلغاء التَّثبيت",
  "column_search.cancel": "إلغاء",
  "combobox.close_results": "إغلاق النتائج",
  "combobox.loading": "جاري التحميل",
  "combobox.open_results": "فتح النتائج",
  "community.column_settings.local_only": "المحلي فقط",
  "community.column_settings.media_only": "الوسائط فقط",
  "community.column_settings.remote_only": "عن بُعد فقط",
  "compose.language.change": "تغيير اللغة",
  "compose.language.search": "البحث عن لغة…",
  "compose.published.body": "نُشِرَ المنشور.",
  "compose.published.open": "افتحه",
  "compose.saved.body": "تم حفظ المنشور.",
  "compose_form.direct_message_warning_learn_more": "تَعَلَّم المَزيد",
  "compose_form.encryption_warning": "إنّ المنشورات على ماستدون ليست مشفرة من الطرف إلى نهاية الطرف. لذا، لا تشارك أي معلومات حساسة عبر ماستدون.",
  "compose_form.hashtag_warning": "لن يُدرَج هذا المنشور تحت أي وسم بما أنَّه غير منشور للعامة. إلّا الرسائل المنشورة للعامة يُمكن البحث عنها بواسطة وسم.",
  "compose_form.lock_disclaimer": "حسابُك غير {locked}. يُمكن لأي شخص مُتابعتك لرؤية (منشورات المتابعين فقط).",
  "compose_form.lock_disclaimer.lock": "مُقفَل",
  "compose_form.placeholder": "فِيمَ تُفكِّر؟",
  "compose_form.poll.duration": "مُدَّة اِستطلاع الرأي",
  "compose_form.poll.multiple": "متعدد الخيارات",
  "compose_form.poll.option_placeholder": "الخيار {number}",
  "compose_form.poll.single": "خيار واحد",
  "compose_form.poll.switch_to_multiple": "تغيِير الاستطلاع للسماح باِخيارات مُتعدِّدة",
  "compose_form.poll.switch_to_single": "تغيِير الاستطلاع للسماح باِخيار واحد فقط",
  "compose_form.poll.type": "الطراز",
  "compose_form.publish": "نشر",
  "compose_form.reply": "ردّ",
  "compose_form.save_changes": "تحديث",
  "compose_form.spoiler.marked": "إزالة تحذير المحتوى",
  "compose_form.spoiler.unmarked": "إضافة تحذير للمحتوى",
  "compose_form.spoiler_placeholder": "تحذير المحتوى (اختياري)",
  "confirmation_modal.cancel": "إلغاء",
  "confirmations.block.confirm": "حظر",
  "confirmations.delete.confirm": "حذف",
  "confirmations.delete.message": "هل أنتَ مُتأكدٌ أنك تُريدُ حَذفَ هذا المنشور؟",
  "confirmations.delete.title": "أتريد حذف المنشور؟",
  "confirmations.delete_collection.confirm": "حذف",
  "confirmations.delete_collection.title": "حذف \"{name}\"؟",
  "confirmations.delete_list.confirm": "حذف",
  "confirmations.delete_list.message": "هل أنتَ مُتأكدٌ أنكَ تُريدُ حَذفَ هذِهِ القائمة بشكلٍ دائم؟",
  "confirmations.delete_list.title": "أتريد حذف القائمة؟",
  "confirmations.discard_draft.confirm": "تجاهل ومتابعة",
  "confirmations.discard_draft.edit.cancel": "استئناف التعديل",
  "confirmations.discard_draft.edit.message": "سيتم تجاهل أي تغييرات قمت بها على هذا المنشور.",
  "confirmations.discard_draft.edit.title": "تجاهل التغييرات على منشورك؟",
  "confirmations.discard_draft.post.cancel": "استئناف المسودة",
  "confirmations.discard_draft.post.message": "عبر الاستمرار سيتم تجاهل المنشور الذي تقوم بكتابته الآن.",
  "confirmations.discard_draft.post.title": "تجاهل مسودة منشورك؟",
  "confirmations.discard_edit_media.confirm": "تجاهل",
  "confirmations.discard_edit_media.message": "لديك تغييرات غير محفوظة لوصف الوسائط أو معاينتها، أتريد تجاهلها على أي حال؟",
  "confirmations.follow_to_list.confirm": "متابعة وأضفه للقائمة",
  "confirmations.follow_to_list.message": "يجب أن تتابع {name} لإضافتهم إلى قائمة.",
  "confirmations.follow_to_list.title": "متابعة المستخدم؟",
  "confirmations.logout.confirm": "خروج",
  "confirmations.logout.message": "متأكد من أنك تريد الخروج؟",
  "confirmations.logout.title": "أتريد المغادرة؟",
  "confirmations.missing_alt_text.confirm": "أضف نصًا بديلًا",
  "confirmations.missing_alt_text.message": "يحتوي منشورك على وسائط دون نص بديل. إضافة أوصاف تساعد على جعل المحتوى متاحاً للمزيد من الأشخاص.",
  "confirmations.missing_alt_text.secondary": "انشر على أي حال",
  "confirmations.missing_alt_text.title": "أضف نصًا بديلًا؟",
  "confirmations.mute.confirm": "أكتم",
  "confirmations.private_quote_notify.cancel": "العودة إلى التحرير",
  "confirmations.private_quote_notify.confirm": "نشر المنشور",
  "confirmations.private_quote_notify.do_not_show_again": "لا تظهر علي هذه الرسالة مجددًا",
  "confirmations.quiet_post_quote_info.dismiss": "لا تُذكرني مرة أخرى",
  "confirmations.quiet_post_quote_info.got_it": "مفهوم",
  "confirmations.quiet_post_quote_info.message": "عندما تقتبس منشورا هادئا للعامة، فإن منشورك سيكون أيضا مخفيا عن الخيوط الزمنية الرائجة.",
  "confirmations.quiet_post_quote_info.title": "اقتباس المنشورات العامة الهادئة",
  "confirmations.redraft.confirm": "إزالة وإعادة الصياغة",
  "confirmations.redraft.message": "هل أنت متأكد من أنك تريد حذف هذا المنشور و إعادة صياغته؟ سوف تفقد جميع الإعجابات و الترقيات أما الردود المتصلة به فستُصبِح يتيمة.",
  "confirmations.redraft.title": "أتريد حذف وإعادة صياغة المنشور؟",
  "confirmations.remove_from_followers.confirm": "إزالة المتابع",
  "confirmations.remove_from_followers.message": "سيتوقف {name} عن متابعتك. هل بالتأكيد تريد المتابعة؟",
  "confirmations.remove_from_followers.title": "إزالة المتابع؟",
  "confirmations.revoke_collection_inclusion.confirm": "أزلني",
  "confirmations.revoke_quote.confirm": "إزالة المنشور",
  "confirmations.revoke_quote.message": "لا يمكن التراجع عن هذا الإجراء.",
  "confirmations.revoke_quote.title": "أتريد إزالة المنشور؟",
  "confirmations.unfollow.confirm": "إلغاء المتابعة",
  "content_warning.hide": "إخفاء المنشور",
  "content_warning.show": "إظهار على أي حال",
  "content_warning.show_more": "إظهار المزيد",
  "content_warning.show_short": "إظهار",
  "conversation.delete": "احذف المحادثة",
  "conversation.mark_as_read": "اعتبرها كمقروءة",
  "conversation.open": "اعرض المحادثة",
  "conversation.with": "مع {names}",
  "copy_icon_button.copied": "نُسِخ إلى الحافظة",
  "copy_icon_button.copy_this_text": "نسخ الرابط إلى الحافظة",
  "copypaste.copied": "تم نسخه",
  "copypaste.copy_to_clipboard": "نسخ إلى الحافظة",
  "directory.federated": "مِن الفديفرس المعروف",
  "directory.local": "مِن {domain} فقط",
  "directory.new_arrivals": "الوافدون الجُدد",
  "directory.recently_active": "نشط مؤخرا",
  "disabled_account_banner.account_settings": "إعدادات الحساب",
  "disabled_account_banner.text": "حسابك {disabledAccount} معطل حاليا.",
  "dismissable_banner.community_timeline": "هذه هي أحدث المنشورات العامة من أشخاص تُستضاف حساباتهم على {domain}.",
  "dismissable_banner.dismiss": "رفض",
  "dismissable_banner.public_timeline": "هذه أحدث المنشورات العامة على الشبكة الفيدرالية التي يتابعها مستخدمي نطاق {domain}.",
  "domain_block_modal.block": "حظر الخادم",
  "domain_block_modal.block_account_instead": "أحجب @{name} بدلاً من ذلك",
  "domain_block_modal.they_can_interact_with_old_posts": "يمكن للأشخاص من هذا الخادم التفاعل مع منشوراتك القديمة.",
  "domain_block_modal.they_cant_follow": "لا أحد من هذا الخادم يمكنه متابعتك.",
  "domain_block_modal.they_wont_know": "لن يَعرف أنه قد تم حظره.",
  "domain_block_modal.title": "أتريد حظر النطاق؟",
  "domain_block_modal.you_will_lose_num_followers": "ستخسر {followersCount, plural, zero {}one {{followersCountDisplay} متابع} two {{followersCountDisplay} متابع} few {{followersCountDisplay} متابعين} many {{followersCountDisplay} متابعين} other {{followersCountDisplay} متابعين}} و {followingCount, plural, zero {}one {{followingCountDisplay} شخص تتابعه} two {{followingCountDisplay} شخص تتابعهما} few {{followingCountDisplay} أشخاص تتابعهم} many {{followingCountDisplay} أشخاص تتابعهم} other {{followingCountDisplay} أشخاص تتابعهم}}.",
  "domain_block_modal.you_will_lose_relationships": "ستفقد جميع المتابعين والأشخاص الذين تتابعهم من هذا الخادم.",
  "domain_block_modal.you_wont_see_posts": "لن ترى منشورات أو إشعارات من المستخدمين على هذا الخادم.",
  "domain_pill.activitypub_lets_connect": "يتيح لك التواصل والتفاعل مع الناس ليس فقط على ماستدون، ولكن عبر تطبيقات اجتماعية مختلفة أيضا.",
  "domain_pill.activitypub_like_language": "إنّ ActivityPub مثل لغة ماستدون التي يتحدث بها مع شبكات اجتماعية أخرى.",
  "domain_pill.server": "الخادِم",
  "domain_pill.their_handle": "مُعرفه:",
  "domain_pill.their_server": "بيتهم الرقمي، حيث تُستضاف كافة منشوراتهم.",
  "domain_pill.their_username": "مُعرّفُهم الفريد على الخادم. من الممكن العثور على مستخدمين بنفس اسم المستخدم على خوادم مختلفة.",
  "domain_pill.username": "اسم المستخدم",
  "domain_pill.whats_in_a_handle": "ما المقصود بالمُعرِّف؟",
  "domain_pill.who_they_are": "بما أن المُعرّفات تحدد هوية الشخص ومكان وجوده، فبإمكانك التفاعل مع الأشخاص عبر الويب الاجتماعي لـ <button>المنصات التي تعمل بواسطة أكتيفيتي بوب</button>.",
  "domain_pill.who_you_are": "بما أن مُعرّفك يحدد هويتك ومكان وجوده، فبإمكانك الآخرين التفاعل معك عبر الويب الاجتماعي لـ <button>المنصات التي تعمل بواسطة أكتيفيتي بوب</button>.",
  "domain_pill.your_handle": "عنوانك الكامل:",
  "domain_pill.your_server": "موطِنك الرقمي، حيث توجد فيه كافة منشوراتك. ألا يعجبك المكان؟ يمكنك الانتقال بين الخوادم في أي وقت واصطحاب متابعيك أيضاً.",
  "domain_pill.your_username": "معرفك الفريد على هذا الخادم. من الممكن العثور على مستخدمين بنفس إسم المستخدم على خوادم مختلفة.",
  "dropdown.empty": "حدد خيارا",
  "email_subscriptions.email": "البريد الإلكتروني",
  "email_subscriptions.form.action": "اشترك",
  "email_subscriptions.submitted.title": "خطوة واحدة أخرى",
  "email_subscriptions.validation.email.invalid": "عنوان البريد الإلكتروني غير صالح",
  "embed.instructions": "يمكنكم إدماج هذا المنشور على موقعكم الإلكتروني عن طريق نسخ الشفرة أدناه.",
  "embed.preview": "إليك ما سيبدو عليه:",
  "emoji_button.activity": "الأنشطة",
  "emoji_button.clear": "امسح",
  "emoji_button.custom": "مخصص",
  "emoji_button.flags": "الأعلام",
  "emoji_button.food": "الطعام والشراب",
  "emoji_button.label": "أدرج إيموجي",
  "emoji_button.nature": "الطبيعة",
  "emoji_button.not_found": "لا توجد هناك وجوه تعبيرية مطابقة",
  "emoji_button.objects": "أشياء",
  "emoji_button.people": "الناس",
  "emoji_button.recent": "المُستخدَمة غالباً",
  "emoji_button.search": "ابحث...",
  "emoji_button.search_results": "نتائج البحث",
  "emoji_button.symbols": "رموز",
  "emoji_button.travel": "الأماكن والسفر",
  "empty_column.account_hides_collections": "اختار هذا المستخدم عدم إتاحة هذه المعلومات للعامة",
  "empty_column.account_suspended": "حساب معلق",
  "empty_column.account_timeline": "لا توجد منشورات هنا!",
  "empty_column.account_unavailable": "الملف التعريفي غير متوفر",
  "empty_column.blocks": "لم تقم بحظر أي مستخدِم بعد.",
  "empty_column.bookmarked_statuses": "ليس لديك أية منشورات في الفواصل المرجعية بعد. عندما ستقوم بإضافة البعض منها، ستظهر هنا.",
  "empty_column.community": "الخيط العام المحلي فارغ. أكتب شيئا ما للعامة كبداية!",
  "empty_column.direct": "لم يتم الإشارة إليك بشكل خاص بعد. عندما تتلقى أو ترسل إشارة، سيتم عرضها هنا.",
  "empty_column.domain_blocks": "ليس هناك نطاقات تم حجبها بعد.",
  "empty_column.explore_statuses": "ليس هناك ما هو متداوَل الآن. عد في وقت لاحق!",
  "empty_column.favourited_statuses": "ليس لديك أية منشورات مفضلة بعد. عندما ستقوم بالإعجاب بواحدة، ستظهر هنا.",
  "empty_column.favourites": "لم يقم أي أحد بالإعجاب بهذا المنشور بعد. عندما يقوم أحدهم بذلك سوف يظهر هنا.",
  "empty_column.follow_requests": "ليس عندك أي طلب للمتابعة بعد. سوف تظهر طلباتك هنا إن قمت بتلقي البعض منها.",
  "empty_column.followed_tags": "لم تُتابع أي وسم بعدُ. ستظهر الوسوم هنا حينما تفعل ذلك.",
  "empty_column.hashtag": "ليس هناك بعدُ أي محتوى ذو علاقة بهذا الوسم.",
  "empty_column.home": "إنّ الخيط الزمني لصفحتك الرئيسة فارغ. قم بمتابعة المزيد من الناس كي يمتلأ.",
  "empty_column.list": "هذه القائمة فارغة مؤقتا و لكن سوف تمتلئ تدريجيا عندما يبدأ الأعضاء المُنتَمين إليها بنشر منشورات.",
  "empty_column.mutes": "لم تقم بكتم أي مستخدم بعد.",
  "empty_column.notification_requests": "لا يوجد شيء هنا. عندما تتلقى إشعارات جديدة، سوف تظهر هنا وفقًا لإعداداتك.",
  "empty_column.notifications": "لم تتلق أي إشعار بعدُ. تفاعل مع المستخدمين الآخرين لإنشاء محادثة.",
  "empty_column.public": "لا يوجد أي شيء هنا! قم بنشر شيء ما للعامة، أو اتبع المستخدمين الآخرين المتواجدين على الخوادم الأخرى لملء خيط المحادثات",
  "empty_state.no_results": "لا توجد نتائج",
  "error.unexpected_crash.explanation": "نظرا لوجود خطأ في التعليمات البرمجية أو مشكلة توافق مع المتصفّح، تعذر عرض هذه الصفحة بشكل صحيح.",
  "error.unexpected_crash.explanation_addons": "لا يمكن عرض هذه الصفحة بشكل صحيح. من المحتمل أن يكون هذا الخطأ بسبب إضافة متصفح أو أدوات ترجمة تلقائية.",
  "error.unexpected_crash.next_steps": "حاول إعادة إنعاش الصفحة. إن لم تُحلّ المشكلة، يمكنك دائمًا استخدام ماستدون عبر متصفّح آخر أو تطبيق أصلي.",
  "error.unexpected_crash.next_steps_addons": "حاول تعطيلهم وإنعاش الصفحة. إن لم ينجح ذلك، يمكنك دائمًا استخدام ماستدون عبر متصفح آخر أو تطبيق أصلي.",
  "errors.unexpected_crash.copy_stacktrace": "انسخ تتبع الارتباطات إلى الحافظة",
  "errors.unexpected_crash.report_issue": "الإبلاغ عن خلل",
  "explore.suggested_follows": "أشخاص",
  "explore.title": "رائج",
  "explore.trending_links": "المُستجدّات",
  "explore.trending_statuses": "المنشورات",
  "explore.trending_tags": "وُسُوم",
  "featured_carousel.header": "{count, plural, zero {}one {منشور معروض} two {منشور معروضَين} few {منشورات معروضة} many {منشورات معروضة} other {منشورات معروضة}}",
  "featured_tags.suggestions.add": "إضافة",
  "featured_tags.suggestions.dismiss": "لا شكراً",
  "filter_modal.added.context_mismatch_explanation": "فئة عامل التصفية هذه لا تنطبق على السياق الذي وصلت فيه إلى هذه المشاركة. إذا كنت ترغب في تصفية المنشور في هذا السياق أيضا، فسيتعين عليك تعديل عامل التصفية.",
  "filter_modal.added.context_mismatch_title": "عدم تطابق السياق!",
  "filter_modal.added.expired_explanation": "انتهت صلاحية فئة عامل التصفية هذه، سوف تحتاج إلى تغيير تاريخ انتهاء الصلاحية لتطبيقها.",
  "filter_modal.added.expired_title": "عامل تصفية انتهت صلاحيته!",
  "filter_modal.added.review_and_configure": "لمراجعة وزيادة تكوين فئة عوامل التصفية هذه، انتقل إلى {settings_link}.",
  "filter_modal.added.review_and_configure_title": "إعدادات التصفية",
  "filter_modal.added.settings_link": "صفحة الإعدادات",
  "filter_modal.added.short_explanation": "تمت إضافة هذا المنشور إلى فئة عوامل التصفية التالية: {title}.",
  "filter_modal.added.title": "تمت إضافة عامل التصفية!",
  "filter_modal.select_filter.context_mismatch": "لا ينطبق على هذا السياق",
  "filter_modal.select_filter.expired": "منتهية الصلاحيّة",
  "filter_modal.select_filter.prompt_new": "فئة جديدة: {name}",
  "filter_modal.select_filter.search": "البحث أو الإنشاء",
  "filter_modal.select_filter.subtitle": "استخدم فئة موجودة أو قم بإنشاء فئة جديدة",
  "filter_modal.select_filter.title": "تصفية هذا المنشور",
  "filter_modal.title.status": "تصفية منشور",
  "filter_warning.matches_filter": "يطابق عامل التصفية “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "من {count, plural, zero {}=0 {لا أحد} one {شخص واحد قد تعرفه} two {# شخص قد تعرفهما} few {# أشخاص قد تعرفهم} many {# أشخاص قد تعرفهم} other {# أشخاص قد تعرفهم}}",
  "filtered_notifications_banner.title": "الإشعارات المصفاة",
  "firehose.all": "الكل",
  "firehose.local": "هذا الخادم",
  "firehose.remote": "خوادم أخرى",
  "follow_request.authorize": "ترخيص",
  "follow_request.reject": "رفض",
  "follow_requests.unlocked_explanation": "حتى وإن كان حسابك غير مقفل، يعتقد فريق {domain} أنك قد ترغب في مراجعة طلبات المتابعة من هذه الحسابات يدوياً.",
  "follow_suggestions.curated_suggestion": "انتقاه الفريق",
  "follow_suggestions.dismiss": "لا تُظهرها مجدّدًا",
  "follow_suggestions.featured_longer": "مختار يدوياً من قِبل فريق {domain}",
  "follow_suggestions.friends_of_friends_longer": "مشهور بين الأشخاص الذين تتابعهم",
  "follow_suggestions.hints.featured": "تم اختيار هذا الملف الشخصي يدوياً من قبل فريق {domain}.",
  "follow_suggestions.hints.friends_of_friends": "هذا الملف الشخصي مشهور بين الأشخاص الذين تتابعهم.",
  "follow_suggestions.hints.most_followed": "هذا الملف الشخصي هو واحد من الأكثر متابعة على {domain}.",
  "follow_suggestions.hints.most_interactions": "هذا الملف الشخصي قد حصل مؤخرا على الكثير من الاهتمام على {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "هذا الملف الشخصي مشابه للملفات الشخصية التي تابعتها مؤخرا.",
  "follow_suggestions.personalized_suggestion": "توصية مخصصة",
  "follow_suggestions.popular_suggestion": "توصية رائجة",
  "follow_suggestions.popular_suggestion_longer": "رائج على {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "مشابهة لمواصفات الملفات الشخصية التي تابعتَها حديثًا",
  "follow_suggestions.view_all": "عرض الكل",
  "follow_suggestions.who_to_follow": "حسابات للمُتابَعة",
  "followed_tags": "الوسوم المتابَعة",
  "following.title": "يتبعه {name}",
  "footer.about": "عن",
  "footer.about_mastodon": "عن ماستدون",
  "footer.about_server": "عن {domain}",
  "footer.about_this_server": "عن",
  "footer.directory": "دليل الصفحات التعريفية",
  "footer.get_app": "احصل على التطبيق",
  "footer.keyboard_shortcuts": "اختصارات لوحة المفاتيح",
  "footer.privacy_policy": "سياسة الخصوصية",
  "footer.source_code": "الاطلاع على الشفرة المصدرية",
  "footer.status": "الحالة",
  "footer.terms_of_service": "شروط الخدمة",
  "form_field.optional": "(اختياري)",
  "generic.saved": "تم الحفظ",
  "getting_started.heading": "استعدّ للبدء",
  "hashtag.admin_moderation": "افتح الواجهة الإشراف لـ #{name}",
  "hashtag.browse": "تصفح المنشورات التي تحتوي #{hashtag}",
  "hashtag.browse_from_account": "تصفح المنشورات من @{name} التي تحتوي على #{hashtag}",
  "hashtag.column_header.tag_mode.all": "و {additional}",
  "hashtag.column_header.tag_mode.any": "أو {additional}",
  "hashtag.column_header.tag_mode.none": "بدون {additional}",
  "hashtag.column_settings.select.no_options_message": "لم يُعثَر على أي اقتراح",
  "hashtag.column_settings.select.placeholder": "قم بإدخال وسوم…",
  "hashtag.column_settings.tag_mode.all": "كلها",
  "hashtag.column_settings.tag_mode.any": "أي كان مِن هذه",
  "hashtag.column_settings.tag_mode.none": "لا شيء مِن هذه",
  "hashtag.column_settings.tag_toggle": "إدراج الوسوم الإضافية لهذا العمود",
  "hashtag.counter_by_accounts": "{count, plural, zero {لَا مُشارك} one {مُشارَك واحد} two {مُشارِكان إثنان} few {{counter} مشاركين} many {{counter} مُشاركًا} other {{counter} مُشارِك}}",
  "hashtag.counter_by_uses": "{count, plural, zero {لَا منشورات} one {منشور واحد} two {منشوران إثنان} few {{counter} منشورات} many {{counter} منشورًا} other {{counter} منشور}}",
  "hashtag.counter_by_uses_today": "{count, plural, zero {لَا منشورات} one {منشور واحد} two {منشوران إثنان} few {{counter} منشورات} many {{counter} منشورًا} other {{counter} منشور}}",
  "hashtag.feature": "اعرضه على صفحتك الشخصية",
  "hashtag.follow": "اتبع الوسم",
  "hashtag.mute": "اكتم #{hashtag}",
  "hashtag.unfeature": "أزله من العرض على الملف الشخصي",
  "hashtag.unfollow": "ألغِ متابعة الوسم",
  "hashtags.and_other": "…و {count, plural, zero {} one {# واحد آخر} two {# اثنان آخران} few {# آخرون} many {# آخَرًا}other {# آخرون}}",
  "hints.profiles.followers_may_be_missing": "قد يكون الأشخاص الذي يتبعهم هذا الملف الشخصي ناقصين.",
  "hints.profiles.follows_may_be_missing": "قد يكون المتابعين لهذا الملف الشخصي ناقصين.",
  "hints.profiles.posts_may_be_missing": "قد تكون بعض المنشورات من هذا الملف الشخصي ناقصة.",
  "hints.profiles.see_more_followers": "عرض المزيد من المتابعين على {domain}",
  "hints.profiles.see_more_follows": "اطلع على المزيد من المتابعين على {domain}",
  "hints.profiles.see_more_posts": "عرض المزيد من المنشورات من {domain}",
  "home.column_settings.show_quotes": "إظهار الاقتباسات",
  "home.column_settings.show_reblogs": "اعرض المعاد نشرها",
  "home.column_settings.show_replies": "اعرض الردود",
  "home.hide_announcements": "إخفاء الإعلانات",
  "home.pending_critical_update.body": "يرجى تحديث خادم ماستدون في أقرب وقت ممكن!",
  "home.pending_critical_update.link": "اطّلع على التحديثات",
  "home.pending_critical_update.title": "تحديث أمان حرج متوفر!",
  "home.show_announcements": "إظهار الإعلانات",
  "ignore_notifications_modal.disclaimer": "لا يمكن لـ Mastodon إبلاغ المستخدمين بأنك قد تجاهلت إشعاراتهم. تجاهل الإشعارات لن يمنع إرسال الرسائل نفسها.",
  "ignore_notifications_modal.filter_instead": "تصفيتها بدلا من ذلك",
  "ignore_notifications_modal.filter_to_act_users": "ستبقى قادراً على قبول المستخدمين أو رفضهم أو الإبلاغ عنهم",
  "ignore_notifications_modal.filter_to_avoid_confusion": "التصفية تساعد على تجنب أي ارتباك",
  "ignore_notifications_modal.filter_to_review_separately": "يمكنك مراجعة الإشعارات المصفاة بشكل منفصل",
  "ignore_notifications_modal.ignore": "تجاهل الإشعارات",
  "ignore_notifications_modal.limited_accounts_title": "تجاهل الإشعارات من الحسابات التي هي تحت الإشراف؟",
  "ignore_notifications_modal.new_accounts_title": "تجاهل الإشعارات الصادرة من الحسابات الجديدة؟",
  "ignore_notifications_modal.not_followers_title": "تجاهل الإشعارات من أشخاص لا يتابعونك؟",
  "ignore_notifications_modal.not_following_title": "تجاهل الإشعارات من أشخاص لا تتابعهم؟",
  "ignore_notifications_modal.private_mentions_title": "تجاهل الإشعارات للرسائل التي لم تطلبها؟",
  "info_button.label": "المساعدة",
  "info_button.what_is_alt_text": "<h1> ماهو النص البديل؟</h1><p> يوفر النص البديل أوصافا للصور للأشخاص الذين يعانون من إعاقات بصرية أو اتصالات شبكة ضعيفة أو أولئك الذين يبحثون عن سياق إضافي.</p><p> يمكنك تحسين إمكانية الوصول والفهم للجميع من خلال كتابة نص بديل واضح وموجز وموضوعي. </p><ul><li> حدد العناصر المهمة</li><li>لخص النص في الصور</li><li>استخدام بنية الجمل العادية</li><li>تجنب المعلومات الزائدة</li><li> ركز على الاتجاهات والنتائج الرئيسية في العناصر المرئية المعقدة (مثل الرسوم البيانية أو الخرائط)</li></ul>",
  "interaction_modal.action": "للتفاعل مع منشور {name}، تحتاج إلى تسجيل الدخول إلى حسابك على أي خادم ماستدون تستخدمه.",
  "interaction_modal.go": "اذهب",
  "interaction_modal.no_account_yet": "لا تملك حساباً بعد؟",
  "interaction_modal.on_another_server": "على خادم مختلف",
  "interaction_modal.on_this_server": "على هذا الخادم",
  "interaction_modal.title": "قم بتسجيل الدخول للمتابعة",
  "interaction_modal.username_prompt": "مثلاً {example}",
  "intervals.full.days": "{number, plural, one {# يوم} other {# أيام}}",
  "intervals.full.hours": "{number, plural, one {# ساعة} other {# ساعات}}",
  "intervals.full.minutes": "{number, plural, one {دقيقة واحدة}two {دقيقتان} other {# دقائق}}",
  "keyboard_shortcuts.back": "للرجوع",
  "keyboard_shortcuts.blocked": "لفتح قائمة المستخدمين المحظورين",
  "keyboard_shortcuts.boost": "لإعادة النشر",
  "keyboard_shortcuts.column": "للتركيز على منشور على أحد الأعمدة",
  "keyboard_shortcuts.compose": "للتركيز على نافذة تحرير النصوص",
  "keyboard_shortcuts.description": "الوصف",
  "keyboard_shortcuts.direct": "لفتح عمود الإشارات الخاصة",
  "keyboard_shortcuts.down": "للانتقال إلى أسفل القائمة",
  "keyboard_shortcuts.enter": "لفتح المنشور",
  "keyboard_shortcuts.favourite": "لإضافة المنشور إلى المفضلة",
  "keyboard_shortcuts.favourites": "لفتح قائمة المفضلات",
  "keyboard_shortcuts.federated": "لفتح الخيط الزمني الفديرالي",
  "keyboard_shortcuts.heading": "اختصارات لوحة المفاتيح",
  "keyboard_shortcuts.home": "لفتح الخيط الرئيسي",
  "keyboard_shortcuts.hotkey": "مفتاح الاختصار",
  "keyboard_shortcuts.legend": "لعرض هذا المفتاح",
  "keyboard_shortcuts.load_more": "للتركيز على زر \"تحميل المزيد\"",
  "keyboard_shortcuts.local": "لفتح الخيط العام المحلي",
  "keyboard_shortcuts.mention": "لذِكر الناشر",
  "keyboard_shortcuts.muted": "لفتح قائمة المستخدِمين المكتومين",
  "keyboard_shortcuts.my_profile": "لفتح ملفك التعريفي",
  "keyboard_shortcuts.notifications": "لفتح عمود الإشعارات",
  "keyboard_shortcuts.open_media": "لفتح الوسائط",
  "keyboard_shortcuts.pinned": "لفتح قائمة المنشورات المثبتة",
  "keyboard_shortcuts.profile": "لفتح الملف التعريفي للناشر",
  "keyboard_shortcuts.quote": "اقتباس المنشور",
  "keyboard_shortcuts.reply": "للردّ",
  "keyboard_shortcuts.requests": "لفتح قائمة طلبات المتابعة",
  "keyboard_shortcuts.search": "للتركيز على البحث",
  "keyboard_shortcuts.spoilers": "لإظهار/إخفاء حقلCW",
  "keyboard_shortcuts.start": "لفتح عمود \"هيا نبدأ\"",
  "keyboard_shortcuts.toggle_hidden": "لعرض أو إخفاء النص مِن وراء التحذير",
  "keyboard_shortcuts.toggle_sensitivity": "لعرض/إخفاء الوسائط",
  "keyboard_shortcuts.toot": "للشروع في تحرير منشور جديد",
  "keyboard_shortcuts.translate": "لترجمة منشور",
  "keyboard_shortcuts.unfocus": "لإلغاء التركيز على حقل النص أو نافذة البحث",
  "keyboard_shortcuts.up": "للانتقال إلى أعلى القائمة",
  "learn_more_link.got_it": "مفهوم",
  "learn_more_link.learn_more": "تعلم المزيد",
  "lightbox.close": "إغلاق",
  "lightbox.next": "التالي",
  "lightbox.previous": "العودة",
  "lightbox.zoom_in": "التكبير إلى الحجم الفعلي",
  "lightbox.zoom_out": "التكبير ليناسب الحجم",
  "limited_account_hint.action": "إظهار الملف التعريفي على أي حال",
  "limited_account_hint.title": "تم إخفاء هذا الملف الشخصي من قبل مشرفي {domain}.",
  "link_preview.author": "مِن {name}",
  "link_preview.more_from_author": "المزيد من {name}",
  "link_preview.shares": "{count, plural, zero {{counter} منشور}one {{counter} منشور} two {{counter} منشور} few {{counter} منشور} many {{counter} منشور} other {{counter} منشور}}",
  "lists.add_member": "إضافة",
  "lists.add_to_list": "إضافة إلى القائمة",
  "lists.add_to_lists": "إضافة {name} إلى القوائم",
  "lists.create": "إنشاء",
  "lists.create_a_list_to_organize": "أنشئ قائمة جديدة لتنظم الصفحة الرئيسة خاصتك",
  "lists.create_list": "إنشاء قائمة",
  "lists.delete": "احذف القائمة",
  "lists.done": "تمّ",
  "lists.edit": "عدّل القائمة",
  "lists.exclusive": "إخفاء الأعضاء في الصفحة الرئيسية",
  "lists.exclusive_hint": "إذا يوجد شخص في هذه القائمة، فقم بإخفائه في صفحتك الرئيسة لتجنب رؤية منشوراته مرتين.",
  "lists.find_users_to_add": "ابحث عن مستخدمين للإضافة",
  "lists.list_members_count": "{count, plural, zero {}one {# عضو} two {# عضو} few {# عضو} many {# عضو} other {# عضو}}",
  "lists.list_name": "اسم القائمة",
  "lists.new_list_name": "اسم القائمة الجديدة",
  "lists.no_lists_yet": "لا توجد قوائم بعد.",
  "lists.no_members_yet": "لا أعضاء حتى الآن.",
  "lists.no_results_found": "لم يتمّ العثور على أي نتيجة.",
  "lists.remove_member": "إزالة",
  "lists.replies_policy.followed": "أي مستخدم متابَع",
  "lists.replies_policy.list": "أعضاء القائمة",
  "lists.replies_policy.none": "لا أحد",
  "lists.save": "حفظ",
  "lists.search": "بحث",
  "lists.show_replies_to": "تضمين الردود من أعضاء القائمة إلى",
  "load_pending": "{count, plural, one {# عنصر جديد} other {# عناصر جديدة}}",
  "loading_indicator.label": "جاري التحميل…",
  "media_gallery.hide": "إخفاء",
  "moved_to_account_banner.text": "حسابك {disabledAccount} معطل حاليًا لأنك انتقلت إلى {movedToAccount}.",
  "mute_modal.hide_from_notifications": "إخفاء من قائمة الإشعارات",
  "mute_modal.hide_options": "إخفاء الخيارات",
  "mute_modal.indefinite": "إلى أن أفسخ كتمها",
  "mute_modal.show_options": "إظهار الخيارات",
  "mute_modal.they_can_mention_and_follow": "سيكون بإمكانه الإشارة إليك ومتابعتك، لكنك لن تره.",
  "mute_modal.they_wont_know": "لن يَعرف أنه قد تم كتمه.",
  "mute_modal.title": "أتريد كتم المُستخدم؟",
  "mute_modal.you_wont_see_mentions": "لن تر المنشورات التي يُشار فيها إليه.",
  "mute_modal.you_wont_see_posts": "سيكون بإمكانه رؤية منشوراتك، لكنك لن ترى منشوراته.",
  "navigation_bar.about": "عن",
  "navigation_bar.account_settings": "كلمة المرور والأمان",
  "navigation_bar.administration": "الإدارة",
  "navigation_bar.advanced_interface": "افتحه في واجهة الويب المتقدمة",
  "navigation_bar.automated_deletion": "الحذف الآلي للمنشورات",
  "navigation_bar.blocks": "الحسابات المحجوبة",
  "navigation_bar.bookmarks": "الفواصل المرجعية",
  "navigation_bar.direct": "الإشارات الخاصة",
  "navigation_bar.domain_blocks": "النطاقات المحظورة",
  "navigation_bar.favourites": "المفضلة",
  "navigation_bar.filters": "الكلمات المكتومة",
  "navigation_bar.follow_requests": "طلبات المتابعة",
  "navigation_bar.followed_tags": "الوسوم المتابَعة",
  "navigation_bar.follows_and_followers": "المتابِعون والمتابَعون",
  "navigation_bar.import_export": "الاستيراد والتصدير",
  "navigation_bar.lists": "القوائم",
  "navigation_bar.live_feed_local": "البث الحي للمنشورات المحلية",
  "navigation_bar.live_feed_public": "البث الحي للمنشورات العالمية",
  "navigation_bar.logout": "خروج",
  "navigation_bar.moderation": "الإشراف",
  "navigation_bar.more": "المزيد",
  "navigation_bar.mutes": "الحسابات المكتومة",
  "navigation_bar.opened_in_classic_interface": "تُفتَح المنشورات والحسابات وغيرها من الصفحات الخاصة بشكل مبدئي على واجهة الويب التقليدية.",
  "navigation_bar.preferences": "التفضيلات",
  "navigation_bar.privacy_and_reach": "الخصوصية و الوصول",
  "navigation_bar.search": "البحث",
  "navigation_bar.search_trends": "البحث / الرائج",
  "navigation_panel.collapse_followed_tags": "طي قائمة الهاشتاقات المتابعة",
  "navigation_panel.collapse_lists": "طي قائمة القائمة",
  "navigation_panel.expand_followed_tags": "توسيع قائمة الهاشتاقات المتابعة",
  "navigation_panel.expand_lists": "توسيع قائمة القائمة",
  "not_signed_in_indicator.not_signed_in": "تحتاج إلى تسجيل الدخول للوصول إلى هذا المصدر.",
  "notification.admin.report": "{name} أبلغ عن {target}",
  "notification.admin.report_account": "{name} أبلغ عن {count, plural, zero {}one {منشور} two {منشورين} few {# منشورات} many {# منشورات} other {# منشورات}} من قبل {target} بسبب {category}",
  "notification.admin.report_account_other": "{name} أبلغ عن {count, plural, zero {}one {منشور} two {منشورين} few {# منشورات} many {# منشورات} other {# منشورات}} من قبل {target}",
  "notification.admin.report_statuses": "{name} أبلغ عن {target} بسبب {category}",
  "notification.admin.report_statuses_other": "{name} أبلغ عن {target}",
  "notification.admin.sign_up": "أنشأ {name} حسابًا",
  "notification.admin.sign_up.name_and_others": "{name} و{count, plural, zero {}one {شخص آخر قاما} two {# آخرون قاموا} few {# آخرون قاموا} many {# آخرون قاموا} other {# آخرون قاموا}} بالتسجيل",
  "notification.annual_report.message": "إن #Wrapstodon الخاص بك لسنة {year} ينتظرك! تعرّف إلى النقاط البارزة واللحظات التي لا تنسى على ماستدون!",
  "notification.annual_report.view": "عرض #Wrapstodon",
  "notification.favourite": "أضاف {name} منشورك إلى مفضلته",
  "notification.favourite.name_and_others_with_link": "{name} و<a>{count, plural, zero {}one {شخص آخر} two {شخصان آخرين} few {# أشخاص آخرون} many {# أشخاص آخرون} other {# أشخاص آخرون}}</a> قاموا بتفضيل منشورك",
  "notification.favourite_pm": "قام {name} بتفضيل إشارتك الخاصة",
  "notification.favourite_pm.name_and_others_with_link": "{name} و<a>{count, plural, zero {}one {شخص آخر} two {شخصان آخرَين} few {# أشخاص آخرون} many {# أشخاص آخرون} other {# أشخاص آخرون}}</a> قاموا بتفضيل إشارتك الخاصة",
  "notification.follow": "يتابعك {name}",
  "notification.follow.name_and_others": "{name} و<a>{count, plural, zero {}one {شخص آخر} two {شخصان آخرين} few {# أشخاص آخرون} many {# أشخاص آخرون} other {# أشخاص آخرون}}</a> قاموا بمتابعتك",
  "notification.follow_request": "لقد طلب {name} متابعتك",
  "notification.follow_request.name_and_others": "{name} و{count, plural, zero {}one {شخص آخر} two {شخصان آخرين} few {# أشخاص آخرون} many {# أشخاص آخرون} other {# أشخاص آخرون}} أرسلوا طلب متابعة لك",
  "notification.label.mention": "إشارة",
  "notification.label.private_mention": "إشارة خاصة",
  "notification.label.private_reply": "رد خاص",
  "notification.label.quote": "اقتبس {name} منشورا لك",
  "notification.label.reply": "ردّ",
  "notification.mention": "إشارة",
  "notification.mentioned_you": "أشارَ إليك {name}",
  "notification.moderation-warning.learn_more": "اعرف المزيد",
  "notification.moderation_warning": "لقد تلقيت تحذيرًا بالإشراف",
  "notification.moderation_warning.action_delete_statuses": "تم حذف بعض من منشوراتك.",
  "notification.moderation_warning.action_disable": "تم تعطيل حسابك.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "بعض من منشوراتك تم تصنيفها على أنها حساسة.",
  "notification.moderation_warning.action_none": "لقد تلقى حسابك تحذيرا بالإشراف.",
  "notification.moderation_warning.action_sensitive": "سيتم وضع علامة على منشوراتك على أنها حساسة من الآن فصاعدا.",
  "notification.moderation_warning.action_silence": "لقد تم تقييد حسابك.",
  "notification.moderation_warning.action_suspend": "لقد تم تعليق حسابك.",
  "notification.own_poll": "انتهى استطلاعك للرأي",
  "notification.poll": "لقد انتهى استطلاع رأي صوتت فيه",
  "notification.quoted_update": "قام {name} بتعديل منشور اقتبسته",
  "notification.reblog": "قام {name} بمشاركة منشورك",
  "notification.reblog.name_and_others_with_link": "{name} و<a>{count, plural, zero {}one {شخص آخر} two {شخصان آخرين} few {# أشخاص آخرون} many {# أشخاص آخرون} other {# أشخاص آخرون}}</a> قاموا بإعادة نشر منشورك",
  "notification.relationships_severance_event": "فقدت الاتصالات مع {name}",
  "notification.relationships_severance_event.account_suspension": "قام مشرف من {from} بتعليق {target}، مما يعني أنك لم يعد بإمكانك تلقي التحديثات منهم أو التفاعل معهم.",
  "notification.relationships_severance_event.domain_block": "قام مشرف من {from} بحظر {target}، بما في ذلك {followersCount} من متابعينك و {followingCount, plural, one {# حساب} other {# حسابات}} تتابعها.",
  "notification.relationships_severance_event.learn_more": "اعرف المزيد",
  "notification.relationships_severance_event.user_domain_block": "لقد قمت بحظر {target}، مما أدى إلى إزالة {followersCount} من متابعينك و {followingCount, plural, one {# حساب} other {# حسابات}} تتابعها.",
  "notification.status": "{name} نشر للتو",
  "notification.update": "عدّلَ {name} منشورًا",
  "notification_requests.accept": "موافقة",
  "notification_requests.accept_multiple": "قبول {count, plural, zero {}one {طلب واحد…} two {# طلب…} few {# طلبات…} many {# طلبات…} other {# طلبات…}}",
  "notification_requests.confirm_accept_multiple.button": "قبول {count, plural, zero {}one {الطلب} two {2 طلب} few {الطلبات} many {الطلبات} other {الطلبات}}",
  "notification_requests.confirm_accept_multiple.message": "أنت على وشك قبول {count, plural, zero {}one {طلب إشعار واحد} two {# طلبات إشعار} few {# طلبات إشعار} many {# طلبات إشعار} other {# طلبات إشعار}}. هل أنت متأكد من أنك تريد المتابعة؟",
  "notification_requests.confirm_accept_multiple.title": "قبول طلبات الإشعار؟",
  "notification_requests.confirm_dismiss_multiple.button": "رفض {count, plural, zero {}one {الطلب} two {2 طلب} few {الطلبات} many {الطلبات} other {الطلبات}}",
  "notification_requests.confirm_dismiss_multiple.message": "أنت على وشك رفض {count, plural, zero {}one {طلب إشعار واحد} two {# طلبات إشعار} few {# طلبات إشعار} many {# طلبات إشعار} other {# طلبات إشعار}}. لن تتمكن من الوصول بسهولة {count, plural, zero {}one {إليه} two {إليهما} few {إليهم} many {إليهم} other {إليهم}} مرة أخرى. هل أنت متأكد من أنك تريد المتابعة؟",
  "notification_requests.confirm_dismiss_multiple.title": "تجاهل طلبات الإشعار؟",
  "notification_requests.dismiss": "تخطي",
  "notification_requests.dismiss_multiple": "رفض {count, plural, zero {}one {# طلب…} two {# طلب…} few {# طلبات…} many {# طلبات…} other {# طلبات…}}",
  "notification_requests.edit_selection": "تعديل",
  "notification_requests.exit_selection": "تمّ",
  "notification_requests.explainer_for_limited_account": "تم تصفية الإشعارات من هذا الحساب لأن الحساب تم تقييده من قبل مشرف.",
  "notification_requests.explainer_for_limited_remote_account": "تم تصفية الإشعارات من هذا الحساب لأنه أو لأن خادمه مقيد من قبل مشرف.",
  "notification_requests.maximize": "تكبير",
  "notification_requests.minimize_banner": "تصغير شريط الإشعارات المُصفاة",
  "notification_requests.notifications_from": "إشعارات من {name}",
  "notification_requests.title": "الإشعارات المصفاة",
  "notification_requests.view": "عرض الإشعارات",
  "notifications.clear": "مسح الإشعارات",
  "notifications.clear_confirmation": "متأكد من أنك تود مسح جميع الإشعارات الخاصة بك و المتلقاة إلى حد الآن ؟",
  "notifications.clear_title": "أترغب في مسح الإشعارات؟",
  "notifications.column_settings.admin.report": "التبليغات الجديدة:",
  "notifications.column_settings.admin.sign_up": "التسجيلات الجديدة:",
  "notifications.column_settings.alert": "إشعارات سطح المكتب",
  "notifications.column_settings.favourite": "المفضلة:",
  "notifications.column_settings.filter_bar.advanced": "عرض جميع الفئات",
  "notifications.column_settings.filter_bar.category": "شريط التصفية السريعة",
  "notifications.column_settings.follow": "متابعُون جُدُد:",
  "notifications.column_settings.follow_request": "الطلبات الجديدة لِمتابَعتك:",
  "notifications.column_settings.group": "قم بتجميعهم",
  "notifications.column_settings.mention": "الإشارات:",
  "notifications.column_settings.poll": "نتائج استطلاع الرأي:",
  "notifications.column_settings.push": "الإشعارات",
  "notifications.column_settings.quote": "الاقتباسات:",
  "notifications.column_settings.reblog": "المعاد نشرها:",
  "notifications.column_settings.show": "اعرِضها في عمود",
  "notifications.column_settings.sound": "أصدر صوتا",
  "notifications.column_settings.status": "منشورات جديدة:",
  "notifications.column_settings.unread_notifications.category": "إشعارات غير مقروءة",
  "notifications.column_settings.unread_notifications.highlight": "علّم الإشعارات غير المقرؤة",
  "notifications.column_settings.update": "التعديلات:",
  "notifications.filter.all": "الكل",
  "notifications.filter.boosts": "المعاد نشرها",
  "notifications.filter.favourites": "المفضلة",
  "notifications.filter.follows": "يتابِع",
  "notifications.filter.mentions": "الإشارات",
  "notifications.filter.polls": "نتائج استطلاع الرأي",
  "notifications.filter.statuses": "تحديثات من الاشخاص الذين تتابعهم",
  "notifications.grant_permission": "منح الإذن.",
  "notifications.group": "{count} إشعارات",
  "notifications.mark_as_read": "وضع علامة مقروءة على جميع الإشعارات",
  "notifications.permission_denied": "تنبيهات سطح المكتب غير متوفرة بسبب رفض أذونات المتصفح مسبقاً",
  "notifications.permission_denied_alert": "لا يمكن تفعيل إشعارات سطح المكتب، لأن إذن المتصفح قد تم رفضه سابقاً",
  "notifications.permission_required": "إشعارات سطح المكتب غير متوفرة لأنه لم يتم منح الإذن المطلوب.",
  "notifications.policy.accept": "قبول",
  "notifications.policy.accept_hint": "إظهار في الإشعارات",
  "notifications.policy.drop": "تجاهل",
  "notifications.policy.drop_hint": "التخلص منها بشكل دائم",
  "notifications.policy.filter": "تصفية",
  "notifications.policy.filter_hint": "إرسال إلى صندوق الإشعارات المصفاة",
  "notifications.policy.filter_limited_accounts_hint": "المحدودة من قبل مشرفي الخادم",
  "notifications.policy.filter_limited_accounts_title": "حسابات تحت الإشراف",
  "notifications.policy.filter_new_accounts.hint": "تم إنشاؤها منذ {days, plural, zero {}one {يوم واحد} two {يومان} few {# أيام} many {# أيام} other {# أيام}}",
  "notifications.policy.filter_new_accounts_title": "حسابات جديدة",
  "notifications.policy.filter_not_followers_hint": "بما في ذلك الأشخاص الذين يتابعونك منذ أقل من {days, plural, zero {}one {يوم واحد} two {يومين} few {# أيام} many {# يوما} other {# أيام}}",
  "notifications.policy.filter_not_followers_title": "أشخاص لا يتابعونك",
  "notifications.policy.filter_not_following_hint": "حتى توافق عليهم يدويا",
  "notifications.policy.filter_not_following_title": "أشخاص لا تتابعهم",
  "notifications.policy.filter_private_mentions_hint": "يتم تصفيتها إلا إن كانت ردًا على أحد ردودك أو إذا كنت متابعا للمرسل",
  "notifications.policy.filter_private_mentions_title": "الإشارات الخاصة غير المرغوب فيها",
  "notifications.policy.title": "إدارة الإشعارات الواردة من…",
  "notifications_permission_banner.enable": "تفعيل إشعارات سطح المكتب",
  "notifications_permission_banner.how_to_control": "لتلقي الإشعارات عندما لا يكون ماستدون مفتوح، قم بتفعيل إشعارات سطح المكتب، يمكنك التحكم بدقة في أنواع التفاعلات التي تولد إشعارات سطح المكتب من خلال زر الـ{icon} أعلاه بمجرد تفعيلها.",
  "notifications_permission_banner.title": "لا تفوت شيئاً أبداً",
  "onboarding.follows.back": "عودة",
  "onboarding.follows.empty": "نأسف، لا يمكن عرض نتائج في الوقت الحالي. جرب البحث أو انتقل لصفحة الاستكشاف لإيجاد أشخاص للمتابعة، أو حاول مرة أخرى.",
  "onboarding.follows.next": "التالي: إعداد ملفك الشخصي",
  "onboarding.follows.search": "بحث",
  "onboarding.follows.title": "للبدء قم بمتابعة أشخاص",
  "onboarding.profile.discoverable": "اجعل ملفي الشخصي قابلاً للاكتشاف",
  "onboarding.profile.discoverable_hint": "عندما تختار تفعيل إمكانية الاكتشاف على ماستدون، قد تظهر منشوراتك في نتائج البحث والمواضيع الرائجة، وقد يتم اقتراح ملفك الشخصي لأشخاص ذوي اهتمامات مماثلة معك.",
  "onboarding.profile.display_name": "الاسم العلني",
  "onboarding.profile.display_name_hint": "اسمك الكامل أو اسمك المرح…",
  "onboarding.profile.finish": "إنهاء",
  "onboarding.profile.note": "نبذة عنك",
  "onboarding.profile.note_hint": "يمكنك @ذِكر أشخاص آخرين أو استعمال #الوسوم…",
  "onboarding.profile.title": "إعداد الملف الشخصي",
  "onboarding.profile.upload_avatar": "تحميل صورة الملف الشخصي",
  "onboarding.profile.upload_header": "تحميل رأسية الملف الشخصي",
  "password_confirmation.exceeds_maxlength": "تأكيد كلمة المرور يتجاوز الحد الأقصى لطول كلمة المرور",
  "password_confirmation.mismatching": "تأكيد كلمة المرور غير مطابق",
  "picture_in_picture.restore": "ضعها مرة أخرى",
  "poll.closed": "انتهى",
  "poll.refresh": "تحديث",
  "poll.reveal": "عرض النتائج",
  "poll.total_people": "{count, plural, one {شخص واحد} two {شخصان} few {# أشخاص} many {# شخصًا} other {# شخصٍ}}",
  "poll.total_votes": "{count, plural, one {# صوت} other {# أصوات}}",
  "poll.vote": "صَوّت",
  "poll.voted": "لقد صوّتت على هذه الإجابة",
  "poll.votes": "{votes, plural, one {# صوت} other {# أصوات}}",
  "poll_button.add_poll": "إضافة استطلاع للرأي",
  "poll_button.remove_poll": "إزالة استطلاع الرأي",
  "privacy.change": "اضبط خصوصية المنشور",
  "privacy.direct.long": "كل من ذُكر في المنشور",
  "privacy.direct.short": "إشارة خاصة",
  "privacy.private.long": "متابعيك فقط",
  "privacy.private.short": "للمتابِعين",
  "privacy.public.long": "أي شخص على أو خارج ماستدون",
  "privacy.public.short": "للعامة",
  "privacy.quote.disabled": "{visibility}، الاقتباس معطل",
  "privacy.quote.limited": "{visibility}، الاقتباسات محدودة",
  "privacy.unlisted.additional": "هذا يتصرف بالضبط مثل النشر للعامة، باستثناء أن المنشور لن يظهر في الموجزات الحية أو في الوسوم أو في الإستكشاف، أو في نتائج بحث ماستدون، حتى وإن قمت بتفعيله على مستوى الحساب.",
  "privacy.unlisted.short": "للعامة دون صخب",
  "privacy_policy.last_updated": "آخر تحديث {date}",
  "privacy_policy.title": "سياسة الخصوصية",
  "quote_error.poll": "الاقتباس غير مسموح باستطلاعات الرأي.",
  "quote_error.quote": "لا يسمح إلا باقتباس واحد في كل مرة.",
  "quote_error.unauthorized": "غير مصرح لك باقتباس هذا المنشور.",
  "recommended": "موصى به",
  "refresh": "أنعِش",
  "regeneration_indicator.please_stand_by": "الرجاء الانتظار.",
  "regeneration_indicator.preparing_your_home_feed": "جارٍ إعداد صفحتك الرئيسة…",
  "relative_time.days": "{number}ي",
  "relative_time.full.days": "منذ {number, plural, zero {} one {# يوم} two {# يومين} few {# أيام} many {# أيام} other {# يوم}}",
  "relative_time.full.hours": "منذ {number, plural, zero {} one {ساعة واحدة} two {ساعتَيْن} few {# ساعات} many {# ساعة} other {# ساعة}}",
  "relative_time.full.just_now": "الآن",
  "relative_time.full.minutes": "منذ {number, plural, zero {} one {دقيقة} two {دقيقتَيْن} few {# دقائق} many {# دقيقة} other {# دقائق}}",
  "relative_time.full.seconds": "منذ {number, plural, zero {} one {ثانية} two {ثانيتَيْن} few {# ثوانٍ} many {# ثانية} other {# ثانية}}",
  "relative_time.hours": "{number}سا",
  "relative_time.just_now": "الآن",
  "relative_time.minutes": "{number}د",
  "relative_time.seconds": "{number}ثا",
  "relative_time.today": "اليوم",
  "remove_quote_hint.button_label": "مفهوم",
  "remove_quote_hint.message": "يمكنك فعل ذلك من خلال قائمة خيارات {icon}.",
  "remove_quote_hint.title": "هل ترغب في إزالة منشورك المقتبس؟",
  "reply_indicator.attachments": "{count, plural, zero {}one {# مرفق} two {# المرفقات} few {# مرفقات} many {# مرفقات} other {# مرفقًا}}",
  "reply_indicator.cancel": "إلغاء",
  "reply_indicator.poll": "استطلاع رأي",
  "report.block": "حظر",
  "report.block_explanation": "لن ترى منشوراته ولن يمكنه متابعتك أو رؤية منشوراتك، سيكون بديهيا له أنه مكتوم.",
  "report.categories.legal": "إشعارات قانونية",
  "report.categories.other": "أخرى",
  "report.categories.spam": "مزعج",
  "report.categories.violation": "المحتوى ينتهك شرطا أو عدة شروط استخدام للخادم",
  "report.category.subtitle": "اختر أفضل تطابق",
  "report.category.title": "وضح لنا ما أمر {type}",
  "report.category.title_account": "ملف تعريفي",
  "report.category.title_status": "منشور",
  "report.close": "تم",
  "report.comment.title": "هل لديك شيء آخر لتخبرنا به؟",
  "report.forward": "التحويل إلى {target}",
  "report.forward_hint": "هذا الحساب ينتمي إلى خادم آخَر. هل تودّ إرسال نسخة مجهولة مِن التقرير إلى هنالك أيضًا؟",
  "report.mute": "كتم",
  "report.mute_explanation": "لن ترى منشوراته. لكن سيبقى بإمكانه متابعتك ورؤية منشوراتك دون أن يعرف أنه مكتوم.",
  "report.next": "التالي",
  "report.placeholder": "تعليقات إضافية",
  "report.reasons.dislike": "لايعجبني",
  "report.reasons.dislike_description": "ألا ترغب برؤيته",
  "report.reasons.legal": "إنه مخالف للقانون",
  "report.reasons.legal_description": "أنت تعتقد أنه ينتهك قانون بلدك أو دولة الخادم",
  "report.reasons.other": "شيء آخر",
  "report.reasons.other_description": "لا تندرج هذه المشكلة ضمن فئات أخرى",
  "report.reasons.spam": "إنه منشور غير مرغوب فيه",
  "report.reasons.spam_description": "روابط خبيثة أو تفاعل كاذب أو ردود متكررة",
  "report.reasons.violation": "ينتهك قواعد الخادم",
  "report.reasons.violation_description": "تعلم أنه ينتهك قواعد محددة",
  "report.rules.subtitle": "اختر كل ما ينطبق",
  "report.rules.title": "ما هي القواعد المنتهكة؟",
  "report.statuses.subtitle": "اختر كل ما ينطبق",
  "report.statuses.title": "هل هناك أي منشورات تدعم صحة هذا التبليغ؟",
  "report.submit": "إرسال",
  "report.target": "ابلغ عن {target}",
  "report.thanks.take_action": "فيما يلي خياراتك للتحكم بما يُعرَض عليك في ماستدون:",
  "report.thanks.take_action_actionable": "في أثناء مراجعتنا للبلاغ، يمكنك اتخاذ إجراء ضد @{name}:",
  "report.thanks.title": "هل ترغب في مشاهدة هذا؟",
  "report.thanks.title_actionable": "شُكرًا لَكَ على الإبلاغ، سَوفَ نَنظُرُ فِي هَذَا الأمر.",
  "report.unfollow": "إلغاء متابعة @{name}",
  "report.unfollow_explanation": "أنت تتابع هذا الحساب، لإزالة مَنشوراته من موجزات خيطك الرئيس، ألغ متابعته.",
  "report_notification.attached_statuses": "{count, plural, one {{count} منشور} other {{count} منشورات}} مرفقة",
  "report_notification.categories.legal": "أمور قانونية",
  "report_notification.categories.legal_sentence": "محتوى غير قانوني",
  "report_notification.categories.other": "آخر",
  "report_notification.categories.other_sentence": "آخر",
  "report_notification.categories.spam": "مزعج",
  "report_notification.categories.spam_sentence": "مزعج",
  "report_notification.categories.violation": "القاعدة المنتهَكة",
  "report_notification.categories.violation_sentence": "انتهاك لقاعدة",
  "report_notification.open": "فتح التقرير",
  "search.clear": "مسح البحث",
  "search.no_recent_searches": "ما من عمليات بحث تمت مؤخرًا",
  "search.placeholder": "ابحث",
  "search.quick_action.account_search": "الملفات التعريفية المطابقة لـ {x}",
  "search.quick_action.go_to_account": "الذهاب إلى الصفحة الشخصية لـ {x}",
  "search.quick_action.go_to_hashtag": "الذهاب إلى وسم {x}",
  "search.quick_action.open_url": "فتح الرابط التشعبي في ماستدون",
  "search.quick_action.status_search": "المنشورات المطابقة لـ {x}",
  "search.search_or_paste": "ابحث أو أدخل رابطا تشعبيا URL",
  "search_popout.full_text_search_disabled_message": "غير متوفر على {domain}.",
  "search_popout.full_text_search_logged_out_message": "متاح فقط عند تسجيل الدخول.",
  "search_popout.language_code": "رمز لغة ISO",
  "search_popout.options": "خيارات البحث",
  "search_popout.quick_actions": "الإجراءات السريعة",
  "search_popout.recent": "عمليات البحث الأخيرة",
  "search_popout.specific_date": "تاريخ محدد",
  "search_popout.user": "مستخدم",
  "search_results.accounts": "الصفحات التعريفية",
  "search_results.all": "الكل",
  "search_results.hashtags": "الوُسوم",
  "search_results.no_results": "لا توجد نتائج.",
  "search_results.no_search_yet": "حاول البحث عن المنشورات، ملفات الشخصية أو الهاشتاقات.",
  "search_results.see_all": "رؤية الكل",
  "search_results.statuses": "المنشورات",
  "search_results.title": "البحث عن \"{q}\"",
  "server_banner.about_active_users": "الأشخاص الذين يستخدمون هذا الخادم خلال الأيام الثلاثين الأخيرة (المستخدمون النشطون شهريًا)",
  "server_banner.active_users": "مستخدم نشط",
  "server_banner.administered_by": "يُديره:",
  "server_banner.is_one_of_many": "{domain} هو واحد من بين العديد من خوادم ماستدون المستقلة التي يمكنك استخدامها للمشاركة في الفديفرس.",
  "server_banner.server_stats": "إحصائيات الخادم:",
  "sign_in_banner.create_account": "أنشئ حسابًا",
  "sign_in_banner.follow_anyone": "تابع أي شخص من عالم الفدرالية وشاهد منشوراته بالترتيب الزمني. دون خوارزميات أو إعلانات أو عنواين مضللة.",
  "sign_in_banner.mastodon_is": "ماستودون هو أفضل وسيلة لمواكبة الأحداث.",
  "sign_in_banner.sign_in": "تسجيل الدخول",
  "sign_in_banner.sso_redirect": "تسجيل الدخول أو إنشاء حساب",
  "skip_links.skip_to_content": "تخطي إلى المحتوى الرئيسي",
  "status.admin_account": "افتح الواجهة الإدارية لـ @{name}",
  "status.admin_domain": "فتح واجهة الإشراف لـ {domain}",
  "status.admin_status": "افتح هذا المنشور على واجهة الإشراف",
  "status.all_disabled": "إعادات النشر والاقتباسات معطلة",
  "status.block": "احجب @{name}",
  "status.bookmark": "أضفه إلى الفواصل المرجعية",
  "status.cancel_reblog_private": "إلغاء إعادة النشر",
  "status.cannot_quote": "غير مصرح لك باقتباس هذا المنشور",
  "status.cannot_reblog": "لا يمكن إعادة نشر هذا المنشور",
  "status.contains_quote": "يحتوي على اقتباس",
  "status.context.loading": "تحميل المزيد من الردود",
  "status.context.loading_success": "تم تحميل ردود جديدة",
  "status.context.more_replies_found": "تم العثور على المزيد من الردود",
  "status.context.retry": "حاول مجددًا",
  "status.context.show": "إظهار",
  "status.continued_thread": "تكملة للخيط",
  "status.copy": "انسخ رابط الرسالة",
  "status.delete": "احذف",
  "status.delete.success": "المنشور محذوف",
  "status.detailed_status": "تفاصيل المحادثة",
  "status.direct": "إشارة خاصة لـ @{name}",
  "status.direct_indicator": "إشارة خاصة",
  "status.edit": "تعديل",
  "status.edited": "آخر تعديل يوم {date}",
  "status.edited_x_times": "عُدّل {count, plural, zero {} one {مرةً واحدة} two {مرّتان} few {{count} مرات} many {{count} مرة} other {{count} مرة}}",
  "status.embed": "الحصول على شيفرة الدمج",
  "status.favourite": "فضّل",
  "status.filter": "تصفية هذا المنشور",
  "status.history.created": "أنشأه {name} {date}",
  "status.history.edited": "عدله {name} {date}",
  "status.load_more": "حمّل المزيد",
  "status.media.open": "اضغط للفتح",
  "status.media.show": "اضغط لإظهارها",
  "status.media_hidden": "وسائط مخفية",
  "status.mention": "أذكُر @{name}",
  "status.more": "المزيد",
  "status.mute": "أكتم @{name}",
  "status.mute_conversation": "كتم المحادثة",
  "status.open": "وسّع هذا المنشور",
  "status.pin": "دبّسه على الصفحة التعريفية",
  "status.quote": "اقتباس",
  "status.quote.cancel": "إلغاء الاقتباس",
  "status.quote_error.filtered": "مُخفي بسبب إحدى إعدادات التصفية خاصتك",
  "status.quote_error.limited_account_hint.action": "إظهاره على أي حال",
  "status.quote_error.not_available": "المنشور غير متوفر",
  "status.quote_error.pending_approval": "المنشور معلق",
  "status.quote_error.pending_approval_popout.body": "في ماستدون، يمكنك التحكم في ما إذا كان بإمكان شخص ما أن يقتبس منك أو لا. هذا المنشور معلق في انتظار الحصول على موافقة الكاتب الأصلي.",
  "status.quote_error.revoked": "تمت إزالة المنشور من قبل صاحبه",
  "status.quote_followers_only": "يمكن فقط للمتابعين اقتباس هذا المنشور",
  "status.quote_manual_review": "الكاتب سوف يراجع يدوياً",
  "status.quote_noun": "اقتباس",
  "status.quote_policy_change": "تغيير من يمكنه الاقتباس",
  "status.quote_post_author": "اقتبس @{name} منشورا",
  "status.quote_private": "المنشورات الخاصة لا يمكن اقتباسها",
  "status.quotes.empty": "لا أحد اقتبس هذا المنشور بعد. عندما يقوم أحدهم بذلك سوف يظهر هنا.",
  "status.read_more": "اقرأ المزيد",
  "status.reblog": "إعادة النشر",
  "status.reblog_or_quote": "إعادة النشر أو اقتباس",
  "status.reblog_private": "شارك مرة أخرى مع متابعيك",
  "status.reblogged_by": "شارَكَه {name}",
  "status.reblogs.empty": "لم يقم أي أحد بمشاركة هذا المنشور بعد. عندما يقوم أحدهم بذلك سوف يظهر هنا.",
  "status.redraft": "إزالة وإعادة الصياغة",
  "status.remove_bookmark": "احذفه مِن الفواصل المرجعية",
  "status.remove_favourite": "إزالة من التفضيلات",
  "status.remove_quote": "إزالة",
  "status.replied_in_thread": "رد في خيط",
  "status.replied_to": "رَدًا على {name}",
  "status.reply": "ردّ",
  "status.replyAll": "رُد على الخيط",
  "status.report": "ابلِغ عن @{name}",
  "status.request_quote": "طلب اقتباس",
  "status.revoke_quote": "إزالة منشوري من اقتباس @{name}",
  "status.sensitive_warning": "محتوى حساس",
  "status.share": "مشاركة",
  "status.show_less_all": "طي الكل",
  "status.show_more_all": "توسيع الكل",
  "status.show_original": "إظهار الأصل",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "ترجمة",
  "status.translated_from_with": "مترجم من {lang} باستخدام {provider}",
  "status.uncached_media_warning": "المعاينة غير متوفرة",
  "status.unmute_conversation": "فك الكتم عن المحادثة",
  "status.unpin": "فك التدبيس من الصفحة التعريفية",
  "subscribed_languages.lead": "فقط المنشورات في اللغات المحددة ستظهر في خيطك الرئيسي وتسرد في الجداول الزمنية بعد تأكيد التغيير. لا تقم بأي خيار لتلقي المنشورات في جميع اللغات.",
  "subscribed_languages.save": "حفظ التغييرات",
  "subscribed_languages.target": "تغيير اللغات المشتركة لـ {target}",
  "tabs_bar.home": "الرئيسية",
  "tabs_bar.menu": "القائمة",
  "tabs_bar.notifications": "الإشعارات",
  "tabs_bar.publish": "منشور جديد",
  "tabs_bar.search": "ابحث",
  "tag.remove": "إزالة",
  "terms_of_service.effective_as_of": "مطبق اعتباراً من {date}",
  "terms_of_service.title": "شروط الخدمة",
  "terms_of_service.upcoming_changes_on": "تغييرات قادمة في تاريخ {date}",
  "time_remaining.days": "{number, plural, one {# يوم} other {# أيام}} متبقية",
  "time_remaining.hours": "{number, plural, one {# ساعة} other {# ساعات}} متبقية",
  "time_remaining.minutes": "{number, plural, one {# دقيقة} other {# دقائق}} متبقية",
  "time_remaining.moments": "لحظات متبقية",
  "time_remaining.seconds": "{number, plural, one {# ثانية} other {# ثوانٍ}} متبقية",
  "trends.counter_by_accounts": "{count, plural, one {شخص واحد} two {شخصان} few {{counter} أشخاصٍ} many {{counter} شخصًا} other {{counter} شخصًا}} {days, plural, one {خلال اليوم الماضي} two {خلال اليومَيْنِ الماضيَيْنِ} few {خلال {days} أيام الماضية} many {خلال {days} يومًا الماضية} other {خلال {days} يومٍ الماضية}}",
  "trends.trending_now": "المتداولة الآن",
  "ui.beforeunload": "سوف تفقد مسودتك إن تركت ماستدون.",
  "units.short.billion": "{count} مليار",
  "units.short.million": "{count} مليون",
  "units.short.thousand": "{count} ألف",
  "upload_area.title": "اسحب ثم أفلت للرفع",
  "upload_button.label": "إضافة وسائط",
  "upload_error.limit": "لقد تم بلوغ الحد الأقصى المسموح به لإرسال الملفات.",
  "upload_error.poll": "لا يمكن إدراج ملفات في استطلاعات الرأي.",
  "upload_error.quote": "تحميل الملفات غير مسموح بها مع الاقتباسات.",
  "upload_form.drag_and_drop.instructions": "لحمل مرفق، اضغط على space أو Enter. وفي أثناء السحب، استخدم مفاتيح الأسهم لتنقل المرفق في أية اتجاه. اضغط على Space أو Enter مجدداً لتنقل المرفق إلى موضعه الجديد، أو اضغط Escape للإلغاء.",
  "upload_form.drag_and_drop.on_drag_cancel": "تم إلغاء السحب. تم إسقاط مرفقات الوسائط {item}.",
  "upload_form.drag_and_drop.on_drag_end": "تم إضافة المرفق {item}.",
  "upload_form.drag_and_drop.on_drag_over": "تم نقل مرفق الوسائط {item}.",
  "upload_form.drag_and_drop.on_drag_start": "تم إضافة المرفق {item}.",
  "upload_form.edit": "تعديل",
  "upload_progress.label": "يرفع...",
  "upload_progress.processing": "تتم المعالجة…",
  "username.taken": "اسم المستخدم هذا مأخوذ. الرجاء محاولة اسم اخر",
  "video.close": "إغلاق الفيديو",
  "video.download": "تنزيل الملف",
  "video.exit_fullscreen": "الخروج من وضع الشاشة المليئة",
  "video.expand": "توسيع الفيديو",
  "video.fullscreen": "ملء الشاشة",
  "video.hide": "إخفاء الفيديو",
  "video.mute": "كتم",
  "video.pause": "إيقاف مؤقت",
  "video.play": "تشغيل",
  "video.skip_backward": "تخطى إلى الوراء",
  "video.skip_forward": "تخطي للأمام",
  "video.unmute": "إلغاء الكتم",
  "video.volume_down": "خفض الصوت",
  "video.volume_up": "رفع الصوت",
  "visibility_modal.button_title": "اختر مدى الظهور",
  "visibility_modal.header": "مدى الظهور والتفاعل",
  "visibility_modal.helper.unlisted_quoting": "عندما يقتبس الناس منك ، فإن منشورهم سيكون أيضا مخفيا عن الخيوط الزمنية الرائجة.",
  "visibility_modal.privacy_label": "مدى الظهور",
  "visibility_modal.quote_followers": "للمتابِعين فقط",
  "visibility_modal.quote_label": "من يستطيع الاقتباس",
  "visibility_modal.quote_nobody": "أنا فقط",
  "visibility_modal.quote_public": "أيا كان",
  "visibility_modal.save": "حفظ"
}
